// Toolbar fixed-bottom qui apparaît quand au moins une écriture est sélectionnée.
// Permet de reclasser en bulk ou de désélectionner.

import { useState } from "react";
import { useSelectionStore } from "../stores/selection-store";
import { ReclassifyMenu } from "./reclassify-menu";

export function BulkToolbar() {
  const selectedIds = useSelectionStore((s) => s.selectedIds);
  const clear = useSelectionStore((s) => s.clear);
  const [menuOpen, setMenuOpen] = useState(false);

  if (selectedIds.size === 0) return null;

  return (
    <>
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-slate-900 text-white rounded-full shadow-lg px-5 py-2.5 flex items-center gap-4">
        <span className="text-sm font-medium">
          {selectedIds.size} écriture{selectedIds.size > 1 ? "s" : ""} sélectionnée{selectedIds.size > 1 ? "s" : ""}
        </span>
        <button
          onClick={() => setMenuOpen(true)}
          className="bg-blue-600 hover:bg-blue-500 text-white text-sm px-3 py-1 rounded-full font-medium"
        >
          Reclasser
        </button>
        <button
          onClick={clear}
          className="text-gray-300 hover:text-white text-sm"
        >
          Annuler
        </button>
      </div>

      {menuOpen && (
        <ReclassifyMenu
          entryIds={Array.from(selectedIds)}
          onClose={() => {
            setMenuOpen(false);
            clear();
          }}
        />
      )}
    </>
  );
}
